import styled from '@emotion/styled'

export const CardTitleWrapper = styled.span`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-auto-columns: auto;
  align-items: center;
`
